enum ManualInputFormSteps {
    upload = 0,
    review = 1,
    finish = 2,
}

export default ManualInputFormSteps;
